import React from 'react';

import './card.less';


export const Card = (props) => (
	<div className="card card-standard">{props.children}</div>
);



// WEBPACK FOOTER //
// ./src/react/card/Card.jsx